import { get, set } from '@/lib/storage';

const STORAGE_KEY = 'ACCESS_TOKEN';

export const getAccessToken = () => get(STORAGE_KEY);

export const setAccessToken = (token) => set(STORAGE_KEY, token);